<template>
  <div>
    <logged-in-header />
    <account-panel />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import accountPanel from "../components/account/AccountPanel";

export default {
  components: {
    loggedInHeader,
    accountPanel
  }
};
</script>
